import React from "react";
import { BarChart } from "@mui/x-charts";

interface MuiBarChartProps {
  xLabels: string[];
  series: { data: number[]; label: string; color?: string }[];
  height?: number;
}

const MuiBarChart: React.FC<MuiBarChartProps> = ({
  xLabels,
  series,
  height = 300,
}) => {
  return (
    <BarChart
      height={height}
      xAxis={[{ data: xLabels, scaleType: "band" }]}
      series={series}
    />
  );
};

export default MuiBarChart;
